var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"display":"flex","justify-content":"center"},style:((_vm.windowWidth > 1000) ? 'height: 150px;' : '')},[(_vm.windowWidth > 1000 && _vm.chechRole())?_c('headMenuLg',{staticClass:"position-fixed w-100",staticStyle:{"z-index":"1000"}}):_vm._e(),(_vm.windowWidth <= 1000)?_c('headMenuSm'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }